import axios from 'axios';

// Define the base URL defaulting to localhost if env var is missing
const rawUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const baseURL = rawUrl.replace(/\/+$/, '');

// Create the Axios instance
const client = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request Interceptor: Attach the bearer token from localStorage
client.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('roar_token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response Interceptor: Handle auth errors and generic network crashes
client.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Check if we didn't receive a response at all (Network Error)
        if (!error.response) {
            const customError = new Error('Unable to connect. Check your connection.');
            // Keep the original error attached just in case
            customError.originalError = error;
            return Promise.reject(customError);
        }

        // Handle 401 Unauthorized globally
        if (error.response.status === 401) {
            // Clear local auth tokens
            localStorage.removeItem('roar_token');

            // Optionally fire a custom event that the root App or AuthProvider can listent to
            window.dispatchEvent(new Event('logout'));

            // If we are not already on the login page, redirect
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }

        return Promise.reject(error);
    }
);

export default client;
